<template lang="html">
    <div class="main_table">
        <div>
            <h2>{{ $t('DirectorioAZ') }}</h2>
        </div>

		<div class="my-5">
			<hotelDropdown v-bind:append_to_body="false" v-bind:current_stay="hotel_id ? hotel_id : ''" v-on:onChangeHotel="onChangeHotel"></hotelDropdown>
		</div>

        <vx-card>			
			<p align="center" v-if="hotel_id != '' && directories.length == 0">
				{{ $t('noDirectory') }}
			</p>

			<p align="center" v-if="no_lang_items">
				{{ $t('noDirectoryLang') }}
			</p>
			
			<div class="mb-3" v-if="hotel_id != '' && itemsList.length > 0 && desc_dir !== null">
                <vs-collapse style="background-color: #ffffff;" class="bg-white desc-collapse">
                    <vs-collapse-item>
                        <div slot="header" class="p-0">
                            <p class="m-0"><b>{{$t('Saber_mais')}}...</b></p>
                        </div>
                        <p v-html="desc_dir.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    </vs-collapse-item>
                </vs-collapse>
            </div>

            <vs-tabs v-if="hotel_id != '' && itemsList.length > 0">
                <vs-tab v-for="(item, index) in itemsList" :key="index" :label="item.name">

					<p align="center" class="mt-5" v-if="item.sub_capitulos.length == 0">
						{{ $t('noItemsAvailable') }}
					</p>

					<vs-table v-if="item.sub_capitulos.length > 0" stripe :data="item.sub_capitulos">
						<template slot-scope="{data}">
							<vs-tr :key="indextr" v-for="(tr, indextr) in item.sub_capitulos">
								<vs-td>
									<strong>{{ tr.nome }}</strong>
									<br />
									{{ tr.descricao }}
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>

<script>
import HotelDropdown from '@/views/components/HotelDropdown.vue';

export default {
  data:()=>({
	directories: [],
	user: JSON.parse(window.localStorage.getItem('userSession')),
	hotel_id: '',
	itemsList: [],
	no_lang_items: false
  }),
  watch : {
	  '$i18n.locale': function(newLang, oldLang) {
		  this.$vs.loading();

		  this.itemsList = [];

		  setTimeout(() => {
			  this.itemsList = this.getByLang(this.directories[0]);

			  this.no_lang_items = this.itemsList.length == 0;
		  }, 1000);
	  }
  },
  computed: {
  	desc_dir: function() {
  		if(this.directories.length > 0 && this.directories[0].visibility == 1) {
  			let d_tmp = this.directories[0].idiomas.find(x => x.language == this.$i18n.locale.toUpperCase() && x.visibility == 1);
  			if(typeof d_tmp !== 'undefined') {
  				return d_tmp.description;
  			}
  			return null;
  		}
  		return null;
  	}
  },
  methods: {
  	onChangeHotel(hotel_id) {
		this.hotel_id = hotel_id;
		this.getDirectories(this.hotel_id);
	},
	getByLang(items) {
		if(!items) {
			this.$vs.loading.close();
			return false;
		}

		let arr = [];

		items.idiomas.forEach(item => {
			if(item.language == this.$i18n.locale.toUpperCase() && item.visibility == 1) {
				arr.push(item.capitulos);
			}
		});

		this.$vs.loading.close();

		return (arr.length > 0) ? arr[0] : [];		  
	  },
	  getDirectories(hotel_id) {
			this.$vs.loading();

            let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/' + this.hotel_id + '/type/0',
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				this.directories = res.data.menus;
				this.itemsList = this.getByLang(this.directories[0]);
				this.no_lang_items = this.itemsList.length == 0;
				this.$vs.loading.close();
			})
			.catch((err) => {
                this.$vs.loading.close();
			});
		},
  },
  created() {
  		if (this.user.hotel.hotel_id) {
			this.hotel_id = this.user.hotel.hotel_id;
			this.getDirectories(this.hotel_id);
		}
	  
  },
  components: {
		HotelDropdown,
    }
}
</script>

